function initGameSearch(
	inputSelector = "#searchGames",
	gameSelector = ".games"
) {
	const searchInput = document.querySelector(inputSelector);
	const games = document.querySelectorAll(gameSelector);

	if (!searchInput || games.length === 0) return;

	searchInput.addEventListener("input", function () {
		const query = this.value.trim().toLowerCase();
		let matchFound = false;

		games.forEach((game) => {
			const title =
				game.querySelector("h2")?.textContent.toLowerCase() || "";
			if (title.includes(query)) {
				game.style.display = "";
				matchFound = true;
			} else {
				game.style.display = "none";
			}
		});

		// ✅ If nothing matches, show everything again
		if (!matchFound && query.length > 0) {
			games.forEach((game) => (game.style.display = ""));
		}
	});
}

function initJsLanguageDropdown() {

    const langs = {
        en: "English",
        cn: "简体中文",
        id: "Bahasa Indonesia",
        kh: "ខ្មែរ",
        kr: "한국어",
        th: "ไทย",
        vn: "Tiếng Việt",
        es: "Español",
        pt: "Português",
        tr: "Türkçe",
    };

    // Find the container
    const container = document.getElementById("gp-language-dropdown");
    if (!container) {
        console.warn("Language dropdown container NOT found");
        return;
    }

    // Host detection
    const host = window.location.hostname.toLowerCase(); // e.g. temp-cn.gpislots.info
    const parts = host.split(".");
    let currentLang = "en";
    let isTemp = false;

    // Detect current lang
    if (parts.length > 2) {
        const match = parts[0].match(/^(temp-)?([a-z]{2})$/);
        if (match) {
            isTemp = !!match[1];
            currentLang = match[2];
        }
    }

    if (!langs[currentLang]) currentLang = "en";

    const baseHost = parts.slice(-2).join(".");

    // Build dropdown HTML
    let html = `
        <button class="btn btn-outline-secondary dropdown-toggle"
                type="button" data-bs-toggle="dropdown" aria-expanded="false">
            ${langs[currentLang]}
        </button>
        <ul class="dropdown-menu">
    `;

    Object.keys(langs).forEach(lang => {
        if (lang === currentLang) return;

        const sub = (isTemp ? "temp-" : "") + lang;
        const url = `https://${sub}.${baseHost}`;

        html += `
            <li>
                <a class="dropdown-item" href="${url}" data-lang="${lang}">
                    ${langs[lang]}
                </a>
            </li>
        `;
    });

    html += `</ul>`;

    container.innerHTML = html;
}


document.addEventListener("DOMContentLoaded", function () {
	initJsLanguageDropdown(); // Handles the language selector
	initGameSearch(); // Handles the game search filter
});
